export default __webpack_public_path__ + "static/N0270-b239deefdb33336ddf333aae8093a8da.png";